import * as React from 'react';
import Button from '@mui/material/Button';
import UploadIcon from '@mui/icons-material/Upload';


export const UploadButton = ({ onClick }) => {
    return (
        <Button variant="contained" startIcon={<UploadIcon />} sx={{
            background: " var(--Light-Verde---light, #88C54B)",
            width: "122px",
            height: "49px",
            padding: "15px 16px",
            borderRadius: "8px",
            fontFamily: "Poppins, sans-serif",
            fontSize: '16px',
            textTransform: 'none',

            '&:hover': {
                backgroundColor: "#88C54B",
            },
        }}
            onClick={onClick}
        >
            Uploads
        </Button>
    );
};


